import firebase from 'firebase';
import { randanimalSync } from 'randanimal';
// import _ from 'lodash'
import uuid from 'uuid/v4';

// Helper to generate new profiles with appropriate starting cash and eduction

const Generate = {

	profile : (gameId, user, leader) => {

		if(!gameId || !user) return false;

		// Generate a starting education between 0 (No Education) and 3 (High School)
		// Square the seed number to make higher education rarer.
		let
		educationSeed = Math.random(),
		education = Math.floor(  Math.pow( educationSeed , 1)  * 3),
		walletSeed = Math.random(),
		wallet = Math.floor( walletSeed  * ( education + 0.5) * 100 ) + 20,
		transactionId = uuid();

		// console.log('randomised seed',educationSeed, ' => rank ', education);
		console.log('new profile',user.uid, user);

		return new Promise((resolve, reject) => {
			let userId = user.uid || uuid(),
			profileRecord = {
				id : userId,
				name: user.displayName || randanimalSync(),
				permission: leader ? 'leader' : 'participant',
				education: education,
				educationUpdated: new Date().getTime(),
				created: new Date().getTime(),
				photoURL: user.uid ? user.photoURL : false,
				transactions: {
					[transactionId] : {
						description: 'Starting Balance',
						amount: wallet,
						created: new Date().getTime()
					}
				}
			},
			userRecord = {
				name : profileRecord.name,
				email : user.email || 'unknown',
				created: new Date().getTime(),
				game: gameId
			};

			firebase.database().ref(`profiles/${gameId}/${userId}`).set(profileRecord)
			.then(response => {
				firebase.database().ref(`users/${uuid()}`).set(userRecord)
				.then(response => {
					console.log('saved profileRecord',profileRecord);
					console.log('saved userRecord',userRecord)
					resolve(profileRecord);
				})
				.catch(error => {
					reject('User creation error')
				})
			})
			.catch(error => {
				reject('Profile creation error')
			})

		})
	}


};

export default Generate;



// WEBPACK FOOTER //
// ./src/components/helpers/generate.js